  function toggleDropdown() {
    const menu = document.getElementById('paginationDropdownMenu');
    const toggle = document.getElementById('paginationDropdownToggle');
    const activediv = toggle.classList.contains('active');
    const isOpen = menu.style.display === 'block';
    menu.style.display = isOpen ? 'none' : 'block';
    if(activediv){
      toggle.classList.remove('active');
    }else{
       toggle.classList.add('active');
    }
    // toggle.classList.add("active");
    toggle.setAttribute('aria-expanded', String(!isOpen));
    
  }

  function goToPage(page) {
    const url = new URL(window.location.href);
    url.searchParams.set('page', page);
    window.location.href = url.toString();
  }

  // Optional: close dropdown on outside click
  document.addEventListener('click', function (e) {
    const dropdown = document.querySelector('.custom-pagination-dropdown');
    if (!dropdown.contains(e.target)) {
      document.getElementById('paginationDropdownMenu').style.display = 'none';
      document.getElementById('paginationDropdownToggle').setAttribute('aria-expanded', 'false');
      document.getElementById('paginationDropdownToggle').classList.remove("active");
    }
  });